var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarGraph = function SvgBarGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.704 2.418a1.429 1.429 0 0 0-.418 1.01v17.143A1.429 1.429 0 0 0 17.714 22h2.857A1.429 1.429 0 0 0 22 20.571V3.43A1.429 1.429 0 0 0 20.571 2h-2.857c-.379 0-.742.15-1.01.418ZM3.43 16.286h2.857v4.285H3.429v-4.285Zm7.142-5.715h2.858v10H10.57v-10Zm-1.01-1.01a1.428 1.428 0 0 0-.418 1.01v10A1.429 1.429 0 0 0 10.57 22h2.858a1.428 1.428 0 0 0 1.428-1.429v-10a1.428 1.428 0 0 0-1.428-1.428H10.57c-.378 0-.742.15-1.01.418Zm-7.143 5.715A1.428 1.428 0 0 0 2 16.286v4.285A1.429 1.429 0 0 0 3.429 22h2.857a1.429 1.429 0 0 0 1.428-1.429v-4.285a1.428 1.428 0 0 0-1.428-1.429H3.429c-.38 0-.743.15-1.01.419Z",
    fill: "#666"
  })));
};
export default SvgBarGraph;